import { render } from "./matrix.vue?vue&type=template&id=0b418a2c&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"

import "./matrix.vue?vue&type=style&index=0&id=0b418a2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b418a2c"]])

export default __exports__